export enum ScreenSize {
  Small = 0,
  Medium = 1,
  Large = 2,
  xLarge = 3,
  xxLarge = 4,
  xxxLarge = 5,
}
